import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IResourcesAlarm } from "../domain/IResourceAlarm";
import { DailyTableService } from "../services/dt.service";

interface dtResourcesState {
  loading: boolean;
  resources: IResourcesAlarm[];
  error: any;
}

const initialState: dtResourcesState = {
  loading: false,
  resources: [],
  error: undefined,
};

export const getBasicDataForResourcesWithAlarms = createAsyncThunk(
  "DailyTable/getBasicDataForResourcesWithAlarms",
  async () => {
    try {
      const result =
        await DailyTableService.getBasicDataForResourcesWithAlarms();
      return result.resources;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtResourcesSlice = createSlice({
  name: "Resources",
  initialState: initialState,
  reducers: {
    setResources: (state, action: PayloadAction<IResourcesAlarm[]>) => {
      state.resources = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBasicDataForResourcesWithAlarms.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getBasicDataForResourcesWithAlarms.fulfilled,
      (state, action) => {
        state.resources = action.payload ? action.payload : [];
        state.loading = false;
      }
    );
    builder.addCase(
      getBasicDataForResourcesWithAlarms.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
  },
});

export const selectState = (state: RootState) => state.dailytable.resources;

export const { setError } = dtResourcesSlice.actions;

export default dtResourcesSlice.reducer;
